import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  GlobalMessageService,
  GlobalMessageType,
  InterceptorUtil,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
  UserIdService
} from "@spartacus/core";
import { Observable } from "rxjs";
import { Ticket } from "../../../../spartacus/custom/cms-components/myaccount/custom-tickets/model/ticket.model";

@Injectable({
  providedIn: 'root',
})
export class CustomOrderReturnService {
  userId: string;

  constructor(
    protected userIdService: UserIdService,
    protected occEndpoints: OccEndpointsService,
    protected globalMessageService: GlobalMessageService,
    protected http: HttpClient
  ) {
    this.userIdService.takeUserId().subscribe(userID => this.userId = userID).unsubscribe();
  }

  validateOrderEmail(data: Ticket): Observable<any> {
    let observable: Observable<any>;
    const url = this.occEndpoints.buildUrl('validateOrderAndEmail', { urlParams: { userId: this.userId } });
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if (this.userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    observable = this.http.post<any>(url, { ...data }, { headers });

    return observable;
  }

  protected showGlobalMessage(messageKey: string, messageType: GlobalMessageType): void {
    this.globalMessageService.add({ key: messageKey }, messageType);
  }
}
